import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { FaShoppingCart,FaBoxes, FaEye, FaHeart, FaStar, FaRulerCombined, FaWater, FaGlassWhiskey, FaFish } from "react-icons/fa";

const AquariumCard = ({ aquarium = {}, onOrderClick }) => {
  const [isHovered, setIsHovered] = useState(false);
  const [isLiked, setIsLiked] = useState(false);
  const [imageLoaded, setImageLoaded] = useState(false);
  const navigate = useNavigate();

  const {
    id,
    name = "حوض بدون اسم",
    price = 0,
    quantity=0,
    image = null,
    size = "غير محدد",
    sold_status= false, // Default to false (available)
    material = "زجاج",
    capacity = "غير محدد",
    type = "حوض سمك",
  } = aquarium;

  const formattedPrice = typeof price === "number" ? price.toFixed(2) : "N/A";

  const getMaterialIcon = (materialType) => {
    const materialStr = materialType.toLowerCase();
    if (materialStr.includes('زجاج') || materialStr.includes('glass')) return <FaGlassWhiskey />;
    if (materialStr.includes('أكريليك') || materialStr.includes('acrylic')) return <FaWater />;
    return <FaGlassWhiskey />;
  };

  const getMaterialColor = (materialType) => {
    const materialStr = materialType.toLowerCase();
    if (materialStr.includes('زجاج') || materialStr.includes('glass')) return '#06b6d4';
    if (materialStr.includes('أكريليك') || materialStr.includes('acrylic')) return '#3b82f6';
    return '#06b6d4';
  };

  // Handle order button click - call the parent's onOrderClick function
  const handleOrderClick = () => {
    if (onOrderClick) {
      const orderItem = {
        id: id,
        name: name,
        price: parseFloat(price) || 0,
        type: "aquarium",
        quantity: quantity,
        size: size,
        material: material,
      };
      onOrderClick(orderItem);
    }
  };
  useEffect(() => {
    const favorites = JSON.parse(localStorage.getItem('favorites') || '[]');
    setIsLiked(favorites.includes(aquarium.id));
  }, [aquarium.id]);

  const toggleFavorite = () => {
    const newLikedState = !isLiked;
    setIsLiked(newLikedState);
    
    // Update localStorage
    const favorites = JSON.parse(localStorage.getItem('favorites') || '[]');
    if (newLikedState) {
      if (!favorites.includes(aquarium.id)) {
        localStorage.setItem('favorites', JSON.stringify([...favorites, aquarium.id]));
      }
    } else {
      localStorage.setItem('favorites', JSON.stringify(favorites.filter(id => id !== aquarium.id)));
    }
  };

  return (
    <>
      {/* Custom Styles */}
      <style>{`
        @keyframes imageReveal {
          from { transform: scale(1.1); opacity: 0; }
          to { transform: scale(1); opacity: 1; }
        }
        @keyframes heartBeat {
          0%, 100% { transform: scale(1); }
          50% { transform: scale(1.2); }
        }
        @keyframes shimmer {
          0% { background-position: -200px 0; }
          100% { background-position: calc(200px + 100%) 0; }
        }
        @keyframes float {
          0%, 100% { transform: translateY(0px); }
          50% { transform: translateY(-10px); }
        }
        @keyframes priceGlow {
          0%, 100% { text-shadow: 0 0 5px rgba(6, 182, 212, 0.5); }
          50% { text-shadow: 0 0 20px rgba(6, 182, 212, 0.8), 0 0 30px rgba(6, 182, 212, 0.6); }
        }
        @keyframes pulse {
          0%, 100% { transform: scale(1); }
          50% { transform: scale(1.05); }
        }
        @keyframes waterRipple {
          0% { transform: scale(1) rotate(0deg); opacity: 0.8; }
          50% { transform: scale(1.1) rotate(180deg); opacity: 0.6; }
          100% { transform: scale(1) rotate(360deg); opacity: 0.8; }
        }
        @keyframes bubbleFloat {
          0%, 100% { transform: translateY(0px) scale(1); }
          25% { transform: translateY(-5px) scale(1.1); }
          50% { transform: translateY(-10px) scale(0.9); }
          75% { transform: translateY(-5px) scale(1.1); }
        }
        
        .aquarium-card {
          transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
        }
        .aquarium-card:hover {
          transform: translateY(-12px) scale(1.02);
          box-shadow: 0 25px 50px -12px rgba(6, 182, 212, 0.4), 0 0 0 1px rgba(6, 182, 212, 0.3) !important;
        }
        
        .aquarium-image-container {
          position: relative;
          overflow: hidden;
        }
        
        .aquarium-image {
          transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
        }
        .aquarium-card:hover .aquarium-image {
          transform: scale(1.08);
        }
        
        .heart-button {
          transition: all 0.2s ease;
          backdrop-filter: blur(10px);
        }
        .heart-button:hover {
          transform: scale(1.1);
          background: rgba(0, 0, 0, 0.8) !important;
        }
        .heart-button.liked {
          animation: heartBeat 0.6s ease-in-out;
          color: #ef4444 !important;
          background: rgba(239, 68, 68, 0.2) !important;
        }
        
        .primary-button {
          background: linear-gradient(135deg, #06b6d4, #0891b2) !important;
          border: none;
          transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
          position: relative;
          overflow: hidden;
        }
        .primary-button:hover {
          background: linear-gradient(135deg, #0891b2, #0e7490) !important;
          transform: translateY(-2px);
          box-shadow: 0 8px 25px rgba(6, 182, 212, 0.4) !important;
        }
        .primary-button:active {
          transform: translateY(0);
        }
        .primary-button::after {
          content: '';
          position: absolute;
          top: 50%;
          left: 50%;
          width: 0;
          height: 0;
          background: rgba(255, 255, 255, 0.2);
          border-radius: 50%;
          transform: translate(-50%, -50%);
          transition: width 0.3s, height 0.3s;
        }
        .primary-button:active::after {
          width: 300px;
          height: 300px;
        }
        
        .secondary-button {
          background: rgba(6, 182, 212, 0.15) !important;
          border: 1px solid rgba(6, 182, 212, 0.4) !important;
          color: #06b6d4 !important;
          transition: all 0.3s ease;
        }
        .secondary-button:hover {
          background: rgba(6, 182, 212, 0.25) !important;
          border-color: rgba(6, 182, 212, 0.6) !important;
          transform: translateY(-1px);
          box-shadow: 0 4px 12px rgba(6, 182, 212, 0.2);
        }
        
        .sold-out-button {
          background: rgba(239, 68, 68, 0.1) !important;
          border: 1px solid rgba(239, 68, 68, 0.3) !important;
          color: #ef4444 !important;
          cursor: not-allowed !important;
          opacity: 0.7;
        }
        
        .loading-skeleton {
          background: linear-gradient(90deg, rgba(51, 65, 85, 0.3) 25%, rgba(71, 85, 105, 0.5) 50%, rgba(51, 65, 85, 0.3) 75%);
          background-size: 200% 100%;
          animation: shimmer 1.5s infinite;
        }
        
        /* Removed infinite animations for performance */
        .info-row {
          transition: all 0.2s ease;
          border-radius: 6px;
          margin: 2px 0;
        }
        .info-row:hover {
          background: rgba(6, 182, 212, 0.08);
          transform: translateX(-3px);
        }
        
        .aquarium-type-badge {
          background: linear-gradient(135deg, rgba(6, 182, 212, 0.15), rgba(8, 145, 178, 0.15));
          border: 1px solid rgba(6, 182, 212, 0.3);
          color: #06b6d4;
          padding: 6px 12px;
          border-radius: 20px;
          font-size: 12px;
          font-weight: 600;
          display: flex;
          align-items: center;
          gap: 6px;
          backdrop-filter: blur(8px);
        }
        
        /* Responsive Design */
        @media (max-width: 640px) {
          .aquarium-card {
            min-height: 480px !important;
          }
          .card-button {
            font-size: 13px !important;
            padding: 10px 12px !important;
          }
          .info-container {
            padding: 10px !important;
          }
        }
        
        @media (max-width: 480px) {
          .aquarium-card {
            min-height: 460px !important;
          }
          .aquarium-image-container {
            height: 200px !important;
          }
          .card-button {
            font-size: 12px !important;
            padding: 8px 10px !important;
            min-height: 40px !important;
          }
        }
      `}</style>

      <div
        className="aquarium-card"
        style={{
          background: "linear-gradient(135deg, rgba(15, 23, 42, 0.80), rgba(30, 41, 59, 0.68))",
          backdropFilter: "blur(2px)",
          borderRadius: "24px",
          overflow: "hidden",
          boxShadow: "0 10px 25px -5px rgba(0, 0, 0, 0.3), 0 0 0 1px rgba(71, 85, 105, 0.2)",
          width: "100%",
          height: "100%",
          minHeight: "540px",
          border: "1px solid rgba(6, 182, 212, 0.2)",
          position: "relative",
          display: "flex",
          flexDirection: "column",
        }}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        {/* Status Badge */}
        {sold_status && (
          <div className="floating-badge" style={{
            position: "absolute",
            top: "16px",
            left: "16px",
            background: "linear-gradient(135deg, #ef4444, #dc2626)",
            color: "white",
            padding: "8px 14px",
            borderRadius: "25px",
            fontSize: "12px",
            fontWeight: "bold",
            zIndex: 10,
            boxShadow: "0 6px 20px rgba(239, 68, 68, 0.4)",
            display: "flex",
            alignItems: "center",
            gap: "6px",
          }}>
            <FaStar size={12} />
            نفذ المخزون
          </div>
        )}

        {/* Like Button */}
   <button
    className={`heart-button ${isLiked ? 'liked' : ''}`}
    onClick={toggleFavorite}  // Changed from setIsLiked
    style={{
      position: "absolute",
      top: "16px",
      right: "16px",
      background: "rgba(0, 0, 0, 0.6)",
      border: "none",
      borderRadius: "50%",
      width: "44px",
      height: "44px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      color: isLiked ? "#ef4444" : "white",
      cursor: "pointer",
      zIndex: 10,
    }}
  >
    <FaHeart size={18} />
  </button>
        {/* Image Container */}
        <div
          className="aquarium-image-container"
          style={{
            width: "100%",
            height: "260px",
            background: "linear-gradient(135deg, rgba(15, 23, 42, 0.25), rgba(30, 41, 59, 0.15))",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            position: "relative",
            flexShrink: 0,
          }}
        >
          {image ? (
            !imageLoaded ? (
              <div className="loading-skeleton" style={{
                width: "100%",
                height: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "#64748b",
                fontSize: "48px",
              }}>
                🐠
              </div>
            ) : null
          ) : (
            <div className="water-icon bubble-effect" style={{
              color: "#64748b",
              fontSize: "64px",
              opacity: 0.5,
            }}>
              <FaWater />
            </div>
          )}
          
          {image && (
            <img
              className="aquarium-image"
              src={image}
              alt={name}
              loading="lazy"
              style={{ 
                width: "100%", 
                height: "100%", 
                objectFit: "cover",
                opacity: imageLoaded ? 1 : 0,
                position: imageLoaded ? "static" : "absolute",
                transition: "opacity 0.3s ease-in-out",
              }}
              onLoad={() => setImageLoaded(true)}
            />
          )}

          {/* Aquarium Type Badge */}
          <div className="aquarium-type-badge" style={{
            position: "absolute",
            bottom: "12px",
            right: "12px",
          }}>
            <FaFish size={12} />
            {type}
          </div>
        </div>

        {/* Content */}
        <div className="info-container" style={{ 
          padding: "20px", 
          display: "flex", 
          flexDirection: "column", 
          flex: 1,
          gap: "16px"
        }}>
          {/* Title and Info */}
          <div style={{
            background: "linear-gradient(135deg, rgba(6, 182, 212, 0.08), rgba(8, 145, 178, 0.08))",
            border: "1px solid rgba(6, 182, 212, 0.2)",
            borderRadius: "16px",
            padding: "16px",
            flex: 1,
          }}>
            <div className="info-row" style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "8px",
              borderBottom: "1px solid rgba(6, 182, 212, 0.15)",
              marginBottom: "8px",
            }}>
              <span style={{ color: "#06b6d4", fontWeight: "bold", fontSize: "14px" }}>
                اسم الحوض
              </span>
              <span style={{ 
                color: "white", 
                fontSize: "15px", 
                fontWeight: "600",
                textAlign: "right",
                wordBreak: "break-word",
                maxWidth: "60%"
              }}>
                {name}
              </span>
            </div>

            <div className="info-row" style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "8px",
              borderBottom: "1px solid rgba(6, 182, 212, 0.15)",
              marginBottom: "8px",
            }}>
              <span style={{ color: "#06b6d4", fontWeight: "bold", fontSize: "14px" }}>
                السعر
              </span>
              <span className="price-tag" style={{ 
                color: "#fbbf24", 
                fontSize: "18px", 
                fontWeight: "bold",
              }}>
                {formattedPrice} DA
              </span>
            </div>

            <div className="info-row" style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "8px",
              borderBottom: "1px solid rgba(6, 182, 212, 0.15)",
              marginBottom: "8px",
            }}>
              <span style={{ color: "#06b6d4", fontWeight: "bold", fontSize: "14px" }}>
                الحجم
              </span>
              <span style={{ 
                color: "white", 
                fontSize: "14px", 
                fontWeight: "600",
                padding: "4px 8px",
                borderRadius: "8px",
                background: "rgba(6, 182, 212, 0.15)",
                display: "flex",
                alignItems: "center",
                gap: "6px",
              }}>
                <FaRulerCombined size={12} />
                {size}
              </span>
            </div>
            <div className="info-row" style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "8px",
              borderBottom: "1px solid rgba(6, 182, 212, 0.15)",
              marginBottom: "8px",
            }}>
              <span style={{ color: "#06b6d4", fontWeight: "bold", fontSize: "14px" }}>
                الكمية
              </span>
              <span style={{ 
                color: "white", 
                fontSize: "14px", 
                fontWeight: "600",
                padding: "4px 8px",
                borderRadius: "8px",
                background: "rgba(6, 182, 212, 0.15)",
                display: "flex",
                alignItems: "center",
                gap: "6px",
              }}>
                <FaBoxes size={12} />
                {quantity}
              </span>
            </div>

            <div className="info-row" style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "8px",
              borderBottom: "1px solid rgba(6, 182, 212, 0.15)",
              marginBottom: "8px",
            }}>
              <span style={{ color: "#06b6d4", fontWeight: "bold", fontSize: "14px" }}>
                المادة
              </span>
              <span style={{ 
                color: getMaterialColor(material), 
                fontSize: "14px", 
                fontWeight: "600",
                padding: "4px 8px",
                borderRadius: "8px",
                background: `${getMaterialColor(material)}15`,
                display: "flex",
                alignItems: "center",
                gap: "6px",
              }}>
                {getMaterialIcon(material)}
                {material}
              </span>
            </div>

            {capacity !== "غير محدد" && (
              <div className="info-row" style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "8px",
                borderBottom: "1px solid rgba(6, 182, 212, 0.15)",
                marginBottom: "8px",
              }}>
                <span style={{ color: "#06b6d4", fontWeight: "bold", fontSize: "14px" }}>
                  السعة
                </span>
                <span style={{ 
                  color: "white", 
                  fontSize: "14px", 
                  fontWeight: "600",
                  padding: "4px 8px",
                  borderRadius: "8px",
                  background: "rgba(6, 182, 212, 0.15)",
                }}>
                  {capacity}
                </span>
              </div>
            )}

            <div className="info-row" style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "8px",
            }}>
              <span style={{ color: "#06b6d4", fontWeight: "bold", fontSize: "14px" }}>
                الحالة
              </span>
              <span className={sold_status ? "" : "status-available"} style={{
                color: sold_status ? "#ef4444" : "#06b6d4",
                fontSize: "14px",
                fontWeight: "600",
                padding: "6px 12px",
                borderRadius: "12px",
                background: sold_status
                  ? "rgba(239, 68, 68, 0.15)" 
                  : "rgba(6, 182, 212, 0.15)",
                display: "flex",
                alignItems: "center",
                gap: "6px",
              }}>
                <FaWater size={12} />
                {sold_status ? "نفذ المخزون" : "متاح"}
              </span>
            </div>
          </div>

          {/* Action Buttons */}
          <div style={{ 
            display: "flex", 
            flexDirection: "column", 
            gap: "12px",
            marginTop: "auto"
          }}>
            {/* Primary Action Button */}
            {!sold_status ? (
              <button 
                className="primary-button card-button"
                onClick={handleOrderClick}
                style={{
                  borderRadius: "16px",
                  padding: "14px 20px",
                  color: "white",
                  fontSize: "15px",
                  fontWeight: "bold",
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "10px",
                  boxShadow: "0 6px 20px rgba(6, 182, 212, 0.3)",
                  minHeight: "52px",
                }}
              >
                <FaShoppingCart size={16} />
                اطلب الآن
              </button>
            ) : (
              <div className="sold-out-button card-button" style={{
                borderRadius: "16px",
                padding: "14px 20px",
                fontSize: "15px",
                fontWeight: "bold",
                textAlign: "center",
                minHeight: "52px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "10px",
              }}>
                <FaStar size={14} />
                نفذ المخزون
              </div>
            )}

            {/* Secondary Action Button
            <button
              className="secondary-button card-button"
              onClick={() => navigate("/aquarium-details", { state: { aquarium } })}
              style={{
                borderRadius: "14px",
                padding: "12px 18px",
                fontSize: "14px",
                fontWeight: "600",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "8px",
                minHeight: "46px",
              }}
            >
              <FaEye size={14} />
              عرض المزيد من التفاصيل
            </button> */}
          </div>
        </div>

        {/* Hover Glow Effect */}
        {isHovered && (
          <div style={{
            position: "absolute",
            inset: 0,
            background: "linear-gradient(135deg, rgba(6, 182, 212, 0.05), rgba(8, 145, 178, 0.05))",
            borderRadius: "24px",
            pointerEvents: "none",
          }} />
        )}
      </div>
    </>
  );
};

export default React.memo(AquariumCard);